"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ColorSchemeContext = void 0;
var _react = require("react");
/**
 * Context for passing the theme's color scheme down the tree.
 */
var ColorSchemeContext = /*#__PURE__*/(0, _react.createContext)("light");
exports.ColorSchemeContext = ColorSchemeContext;
var useColorScheme = function useColorScheme() {
  return (0, _react.useContext)(ColorSchemeContext);
};
var _default = useColorScheme;
exports["default"] = _default;